<template>
    <div class="f-info">
        <div class="title">
            <div class="title__folder-name">
                <p class="text">{{ selectedItem.title ? selectedItem.title : selectedItem.name}}</p>
                <svg @click="closeInfo" class="close-btn" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 4.66673L4 14.6667M3.99996 4.66669L13.9999 14.6666" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
            </div>
            <p v-if="selectedItem.contents" class="title__files-quantity">Файлов: {{ selectedItem.contents.length }}</p>
        </div>

        <div v-if="selectedItem.contents" class="body">
            <div v-for="item in selectedItem.contents">
                <img v-if="item.type_id == 1" :src="`${domain}${item.path}`" alt="">
                <video v-else-if="item.type_id == 2" controls autoplay loop>
                    <source :src="`${domain}${item.path}`">
                </video>
            </div>
        </div>
            
        <div v-if="!selectedItem.contents" class="body__single-element">
            <img v-if="selectedItem.type_id == 1" :src="`${domain}${selectedItem.path}`" alt="">
            <video v-else-if="selectedItem.type_id == 2" controls autoplay loop>
                <source :src="`${domain}${selectedItem.path}`">
            </video>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "ContentInfoComponent",

    props: {
        domain: String
    },

    emits: [
        'closeInfo'
    ],

    computed: {
        ...mapState('content', ['selectedItem']),

        images() {
            let images = [];
            this.selectedItem.contents.forEach(content => {
                if (content.type_id == 1) images.push(content);
            });
            return images;
        },

        videos() {
            let videos = [];
            this.selectedItem.contents.forEach(content => {
                if (content.type_id == 2) videos.push(content);
            });
            return videos;
        }
    },

    methods: {
        closeInfo() {
            this.$emit('closeInfo');
        }
    },
}
</script>

<style scoped lang="scss">

</style>